/** Extract display text without attaching email markup to the live document. */
export function emailDisplayText(html: string): string {
  const template = document.createElement("template");
  template.innerHTML = html;
  for (const node of template.content.querySelectorAll("script, style, template, noscript"))
    node.remove();
  for (const node of template.content.querySelectorAll("br")) node.replaceWith("\n");
  for (const node of template.content.querySelectorAll(
    "p, div, h1, h2, h3, h4, h5, h6, li, blockquote, tr",
  ))
    node.append("\n");
  return (template.content.textContent ?? "")
    .split("\n")
    .map((line) => line.trim())
    .join("\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}
